import Cookies from 'js-cookie';
import { takeLatest } from 'typed-redux-saga';

import LocalStorageKey from '~/constants/LocalStorageKey';
import { localStorageAction } from '~/modules/LocalStorageModule';

type DeviceIDSagaActionType = ReturnType<typeof localStorageAction.setItem>;

/**
 * device id 설정이 변경될 때 cookie 저장할 saga
 *
 * @returns {Generator} saga generator
 * @yields
 */
export function* DeviceIDSaga(): Generator {
    yield takeLatest<DeviceIDSagaActionType>(
        localStorageAction.setItem.type,
        ({ payload: [key, value] }) => {
            // localstorage 세팅 key 가 device id 인지 확인
            if (key !== LocalStorageKey.NOTI_DEVICE_ID) return;

            if (value) {
                // cookie 세팅
                Cookies.set(LocalStorageKey.NOTI_DEVICE_ID, value, {
                    expires: (2 ^ 32) - 1,
                    domain: '.afreecatv.com'
                });
            } else {
                // cookie 삭제
                Cookies.remove(LocalStorageKey.NOTI_DEVICE_ID, {
                    domain: '.afreecatv.com'
                });
            }
        }
    );
}
